import { render, staticRenderFns } from "./SysCategoriasAutocomplete.vue?vue&type=template&id=3589afa9&scoped=true"
import script from "./SysCategoriasAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysCategoriasAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589afa9",
  null
  
)

export default component.exports